import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "@madmedical/i18n";
import useUpload from "../form/upload/useUpload";
import DocumentUploadFormInner from "../organisms/DocumentUploadFormInner";
import ModalContent from "../molecules/ModalContent";
import Button from "../atoms/Button";
import useResponsive from "../util/useResponsive";
const DocumentUploadModalForm = ({ onClose, onSubmit, isUploading }) => {
    const { isSmallScreen } = useResponsive();
    const { files, resetFiles, formProps } = useUpload();
    const { t } = useTranslation();
    const handleSubmitPress = useCallback(() => {
        void onSubmit(files).then(() => {
            resetFiles();
        });
    }, [files, onSubmit, resetFiles]);
    const showUploadButton = (isSmallScreen && files.length > 0) || !isSmallScreen;
    return (_jsx(ModalContent, Object.assign({ header: t("uploadDocument"), shadow: "3", borderBottomWidth: 0, footer: _jsxs(_Fragment, { children: [!isSmallScreen && (_jsx(Button, Object.assign({ variant: "outlined", onPress: onClose }, { children: t("cancel") }))), showUploadButton && (_jsx(Button, Object.assign({ isLoading: isUploading, isLoadingText: `${t("uploadFiles")}…`, isDisabled: !files.length, onPress: handleSubmitPress, variant: "primary" }, { children: t("uploadFiles") })))] }) }, { children: _jsx(DocumentUploadFormInner, Object.assign({}, formProps, { files: files.map(({ file: { name, size }, note }) => ({
                name,
                size,
                note,
            })), isUploading: isUploading })) })));
};
export default DocumentUploadModalForm;
